import { useCallback } from 'react';

export const useFormHandlers = (setFormValues) => {
  const handleChange = useCallback((field, value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  }, [setFormValues]);

  const handleFileChangeLocal = useCallback((e, field) => {
    const file = e.target.files[0];
    if (file) {
      setFormValues((prevValues) => ({
        ...prevValues,
        [field]: file,
      }));
    }
  }, [setFormValues]);

  const handleRemoveImageLocal = useCallback((field) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [field]: null,
    }));
  }, [setFormValues]);

  return {
    handleChange,
    handleFileChangeLocal,
    handleRemoveImageLocal,
  };
};
